// GitHub theme
import { Theme } from 'react-activity-calendar';

export const API_URL = 'https://github-contributions-api.jogruber.de/v4/';

export const DEFAULT_THEME: Theme = {
  level4: '#216e39',
  level3: '#30a14e',
  level2: '#40c463',
  level1: '#9be9a8',
  level0: '#ebedf0',
};
